import HotelIcon from '@mui/icons-material/Hotel';
import LocationCityIcon from '@mui/icons-material/LocationCity';
import { Autocomplete, Box, CircularProgress, TextField, ThemeProvider, Typography, createTheme } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { createGlobalStyle } from "styled-components";
import { getIBE_API } from '../getAPIUrl';
import { ibeAuthenticatedFetch } from '../ibeAuth';
import { useTranslation } from '../utility/function/useTranslations';
import { setDlysxParamValue } from '../widget-control/WidgetHelper';
enum locationType {
  country,
  city,
  property,
  pincode
}
interface ILocation {
  location?: string;
  id?: string;
  type: locationType;
}
const removeDuplicateFromArray = (arrayItems: any[]) => {
  const jsonObject = arrayItems.map(x => JSON.stringify(x));
  const uniqueSet = new Set(jsonObject);
  return Array.from(uniqueSet).map(y => JSON.parse(y));
}
function SearchControl(props: any) {
  const { brandID, chainID, touched, disableSearchControl, defaultPropCode, errors, setFieldValue, setMaxChildAge, fontColor, setDestinationList, values, booknowbuttoncolor, booknowbuttonhovercolor, booknowbuttonfontcolor, buttonHoverFontColor, backgroundColor, setPageLoaded, setEventType, eventType, setDlysxParam, isDayBooking, setFieldError, locale, showDestinationSearch = true } = props
  const [response, setResponse] = useState<any>([]);
  const [options, setOptions] = useState<any>([]);
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [inFocus, setInFocus] = useState(false);

  const { t } = useTranslation();
  useEffect(() => {
    setLoading(true);
    const fetchLocationData = async () => {
      // TODO : fetch URL from config
      const IBE_lOCATION_API = getIBE_API();

      ibeAuthenticatedFetch(brandID, chainID, `${IBE_lOCATION_API}/Search/getLocationInfo?brandID=${brandID}&chainID=${chainID}&languageCode=${locale}&isDayBooking=${isDayBooking || false}`)
        .then((response: any) => response.json())
        .then((data) => {
          if (data?.status) {
            let locations: ILocation[] = [];
            setMaxChildAge(data?.body[0]?.childAgeLimit || 6)
            const response = data.body;
            setResponse(response)
            // Extract cities and properties only (no countries)
            // Get unique cities first
            const uniqueCities = Array.from(new Set(response.map((item: any) => item.cityId))).sort((a: any, b: any) => {
                let n1 = response.find((item: any) => item.cityId === a)?.city;
                let n2 = response.find((item: any) => item.cityId === b)?.city;
                return n1?.localeCompare(n2);
            });

            uniqueCities.forEach(cityId => {
              const cityData = response.find((item: any) => item.cityId === cityId);
              if (cityData && cityData.city) {
                // Add city
                locations.push({
                  id: cityData.cityId,
                  location: cityData.city,
                  type: locationType.city
                });

                // Get properties for this city
                const cityProperties = response.filter((item: any) =>
                  item.cityId === cityId &&
                  item.propertyId &&
                  item.name
                ).sort((a: any, b: any) => a.name.localeCompare(b.name));

                // Add properties for this city
                cityProperties.forEach((property: any) => {
                  locations.push({
                    id: property.propertyId,
                    location: property.name,
                    type: locationType.property
                  });
                });
              }
            });
            locations = removeDuplicateFromArray(locations);
            setDestinationList(response)
            const isExist = locations.some((item: any) => (item.id == values?.destination?.id));
            const propId = data?.body?.find((item: any) => item.code === defaultPropCode)?.propertyId;
            if (response.length === 1 || !showDestinationSearch) {
              const selectedProperty = locations.find(x => x.id === response[0].propertyId);
              if (selectedProperty) {
                onChangeAutoComplete('', selectedProperty, setFieldValue, touched);
              }
            } else if (propId) {
              // Set default location if defaultPropCode is provided
              const defaultLocation = locations.find(x => x.id === propId);
              if (defaultLocation) {
                onChangeAutoComplete('', defaultLocation, setFieldValue, touched);
              }
            }
            else if (isExist) {
              onChangeAutoComplete('', values?.destination, setFieldValue, touched);
            }
            else {
              // Reset destination when stay type changes
              setFieldValue('destination', { location: '', type: 0, id: '' }, true);
              setFieldError('destination', '');
            }

            setOptions(locations);
            // setLocations(locations)
            setLoading(false);
          }
        }
        );
    }
    fetchLocationData();
  }, [isDayBooking, showDestinationSearch]);

  useEffect(() => {
    const loadMHSDetailData = async () => {
      const IBE_lOCATION_API = getIBE_API();
      ibeAuthenticatedFetch(brandID, chainID, `${IBE_lOCATION_API}/Search/GetMHSPropID?propId=${response[0].propertyId}`)
        .then((result: any) => result.json())
        .then((data) => {
          if (data?.body?.mhsPropertyID !== null && data?.body?.mhsPropertyID !== '') {
            (function (d: Document, s: string) {
              const scriptUrl = `https://d.myhotelshop.com/js/${data?.body?.mhsPropertyID}`;
              const existingScript = d.querySelector(`script[src="${scriptUrl}"]`);
              if (!existingScript) {
                const f = d.getElementsByTagName(s)[0];
                const j = d.createElement(s) as HTMLScriptElement;
                j.async = true;
                j.src = scriptUrl;
                j.onload = () => {
                  setTimeout(() => {
                    setDlysxParamValue(setDlysxParam);
                  }, 1000);
                };
                if (f && f.parentNode) {
                  f.parentNode.insertBefore(j, f);
                } else {
                  // If no <script> tag is found, append to <head> or <body>
                  (d.head || d.body).appendChild(j);
                }
              } else {
                // If script already exists, call setDlysxParamValue immediately
                setDlysxParamValue(setDlysxParam);
              }
            })(document, 'script');
          } else {
            setDlysxParamValue('-1');
          }
        });
    }
    if (response.length > 0) {
      loadMHSDetailData();
    }
  }, [response])

  useEffect(() => {
    if (eventType != '' && inFocus) {
      setOpen(true);
    } else {
      setOpen(false);
    }
  }, [eventType, inFocus])

  const styles = {
    '& .MuiFormLabel-filled': {
      color: '#9ca5ac !important'
    },
    '& label.Mui-focused': {
      color: 'green'
    },
    '& .MuiAutocomplete-popupIndicator': {
      display: 'none'
    },
    '& .MuiOutlinedInput-root': {
      paddingRight: '40px',
      '& fieldset': {
        borderColor: 'transparent',
        border: 'none',
        color: '#9ca5ac'
      },
      '&:hover fieldset': {
        borderColor: 'transparent',
        border: 'none',
        color: '#9ca5ac'
      },
      '&.Mui-focused fieldset': {
        //borderColor: 'white',
        border: '0px',
        color: '#9ca5ac'
      },
      'input': {
        '&::placeholder': {
          fontSize: '14px !important',
          fontWeight: 300,
          color: `${fontColor} !important`,
          opacity: 1
        }
      }
    },
    '&.MuiAutocomplete-root .MuiAutocomplete-clearIndicator': {
      color: `${fontColor} !important `,
      backgroundColor: `inherit !important`,
      padding: '0px !important'
    },
    '&.MuiAutocomplete-clearIndicator:hover': {
      backgroundColor: `inherit !important`,
    },
    '&.MuiButtonBase-root-MuiIconButton-root-MuiAutocomplete-clearIndicator': {
      color: `${fontColor} !important `
    },
    '&.MuiAutocomplete-root .MuiAutocomplete-clearIndicator .MuiSvgIcon-root': {
      color: `${fontColor} !important `
    },
  }

  const onChangeAutoComplete = (event: any, value: any, setFieldValue: any, touched: any) => {
    touched.destination = {
      location: true,
      type: true
    }
    setPageLoaded(true);
    setFieldValue('destination', value, true);
    //  setInFocus(false);
  }

  const theme = createTheme({
    components: {
      MuiAutocomplete: {
        styleOverrides: {
          paper: {
            // Increase the width of the options container
            width: 400, // Increased width for better display
            left: '30px',
            marginLeft: '-20px',
            marginTop: '-3px',
            borderRadius: '8px',
            boxShadow: '0 4px 20px rgba(0,0,0,0.15)',
            border: '1px solid #e0e0e0'
          },
          input: {
            color: `${fontColor} !important`,
          },
        },
      },
    },
  });

  const filterOptions = (options: any, { inputValue }: any) => {
    if (inputValue === "") {
      // setOpenSearch(false)
      return options?.filter((option: any) => {
        return option?.type !== locationType.pincode && option?.type !== locationType.country
      })
    }
    return options?.filter((option: any) =>
      option?.location?.toLowerCase()?.includes(inputValue?.toLowerCase()) &&
      option?.type !== locationType.country
    );
  };

  const renderOption = (props: any, option: any, { selected }: any) => (
    <li {...props}>
      {option?.type === locationType.property ?
        <Box display={'flex'} alignItems={'center'} sx={{ gap: 2, paddingLeft: '20px' }}>
          <HotelIcon sx={{ color: '#666', fontSize: '20px' }} />
          <Box display={'flex'} flexDirection={'column'} sx={{ flex: 1 }}>
            <Typography sx={{
              color: '#333',
              fontWeight: '500',
              fontSize: '14px',
              lineHeight: '1.2',
              mb: 0.5
            }}>
              {getPropertyDisplay(option?.location)}
            </Typography>
            <Typography sx={{
              color: '#666',
              fontSize: '12px',
              textTransform: 'uppercase',
              letterSpacing: '0.5px'
            }}>
              {t("widget", "property", locale)}
            </Typography>
          </Box>
        </Box>
        :
        <Box display={'flex'} alignItems={'center'} sx={{ gap: 2 }}>
          <LocationCityIcon sx={{ color: '#666', fontSize: '20px' }} />
          <Box display={'flex'} flexDirection={'column'} sx={{ flex: 1 }}>
            <Typography sx={{
              color: '#333',
              fontWeight: '500',
              fontSize: '15px',
              lineHeight: '1.2',
              mb: 0.5
            }}>
              {option?.location}
            </Typography>
            <Typography sx={{
              color: '#666',
              fontSize: '12px',
              textTransform: 'uppercase',
              letterSpacing: '0.5px'
            }}>
              {t("widget", "city", locale)}
            </Typography>
          </Box>
        </Box>
      }
    </li>
  );

  const GlobalStyles = createGlobalStyle`
    .MuiAutocomplete-popper div.MuiPaper-root{
      display: ${open ? "block" : "none"}
    }
    .MuiAutocomplete-listbox {
      cursor: pointer
    }
    .MuiAutocomplete-listbox .MuiAutocomplete-option[aria-selected="true"] {
      background-color: ${booknowbuttoncolor} !important;
    }
    .MuiAutocomplete-listbox .MuiAutocomplete-option[aria-selected="true"] p, .MuiAutocomplete-listbox .MuiAutocomplete-option[aria-selected="true"] svg {
      color: ${booknowbuttonfontcolor} !important;
    }
    .MuiAutocomplete-listbox .MuiAutocomplete-option.Mui-focused p, .MuiAutocomplete-listbox .MuiAutocomplete-option.Mui-focused svg {
      color: ${buttonHoverFontColor} !important;
    }
    .MuiAutocomplete-listbox .MuiAutocomplete-option.Mui-focused {
      background-color: ${booknowbuttonhovercolor} !important;
    }
  `

  function getPropertyDisplay(location: any): React.ReactNode {
    // Find the property data to get city information
    const propertyData = response.find((x: any) => x.name?.toLowerCase() === location?.toLowerCase());
    const cityName = propertyData?.city;

    if (cityName) {
      return <Typography>{location}, <b>{cityName}</b></Typography>
    }

    return <Typography>{location}</Typography>
  }

  const renderInput = (params: any) => (
    <TextField
      {...params}
      placeholder={t("widget", "enterDestination", locale)}
      required={true}
      error={Boolean(touched.destination && errors.destination)}
      InputProps={{
        ...params.InputProps,
        endAdornment: params.inputProps.value && (
          <>
            {loading && <CircularProgress size={20} />}
            {params.InputProps.endAdornment}
          </>
        ),
      }}
    />
  );

  if (!showDestinationSearch) {
    return null;
  }

  return (
    <Box>
      <GlobalStyles />
      <ThemeProvider theme={theme}>
        <Autocomplete
          // componentsProps={{ popper: { style: { width: '370px' } } }}
          //open={true}
          sx={{
            ...styles, position: 'relative', top: '-8px', left: '-10px', border: 'none', '&:hover': {
              'border': 'none'
            }
          }}
          disabled={disableSearchControl}
          value={values?.destination}
          noOptionsText={t("widget", "noLocationFound", locale)}
          onChange={(event, value) => onChangeAutoComplete(event, value, setFieldValue, touched)}
          onBlur={() => { setOpen(false); setInFocus(false); setEventType(""); }}
          onFocus={() => { setInFocus(true); setOpen(true); }}
          options={options}
          getOptionLabel={(option) => option.location}
          filterOptions={filterOptions}
          renderInput={renderInput}
          renderOption={renderOption}

        />
      </ThemeProvider>
    </Box>
  )
}

export default SearchControl